<template>
  <div class="swiper-card card-coaching">
    <div class="corner-radius-blur" :class="getStackFocus"></div>
    <div class="coach-left">
      <div class="image-container" v-if="feature.images">
        <img class="light" :src="feature.images.light">
        <img class="dark" :src="feature.images.dark">
      </div>

      <div class="dial-container" v-if="feature.dial">
        <UserTrack :size="130" :progress="progress" :focus="feature.dial" mode="demo" />
      </div>

      <div class="detox-container" v-if="feature.detox">
        <div class="icon" :class="getStackFocus">
          <base-svg :svg="getDetox" height="3rem" />
        </div>
      </div>

      <div class="image-icon" v-if="feature.icon" :class="getStackFocus">
        <base-svg :svg="feature.icon" height="50px" />
      </div>
    </div>

    <div class="onboarding-content" :class="feature.align">
      <h1 v-html="feature.title" :class="getStackFocus"></h1>
      <div v-if="feature.paragraphs()" class="paragraph-group">
        <p v-for="(para, i) in feature.paragraphs()" :key="`para-${i}`" v-html="para" :class="getStackFocus"></p>
      </div>
    </div>

    <div v-if="feature.meta" class="meta-block">
      <MetaBlock :theme="getStackFocus ? getStackFocus : null" :items="feature.meta" />
    </div>

    <div class="tab-callout-marker" v-if="feature.tabCallout" :class="getStackFocus">
      <span v-html="feature.tabCallout"></span>
      <svg width="36" height="44" viewBox="0 0 36 44" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M0 0.795711C1.83903 -0.403354 3.64468 -0.0480496 5.26089 0.56486C7.48957 1.41 9.715 2.42594 11.6967 3.74367C20.7769 9.78168 26.1581 18.4067 28.4435 29.029C29.0317 31.7628 29.1948 34.5897 29.5862 37.6306C32.094 36.1827 33.3638 33.3736 35.9086 31.7023C36.236 32.9536 35.6189 33.765 35.0869 34.4915C33.0043 37.3355 30.894 40.1614 28.7061 42.9233C27.644 44.264 26.8187 44.3416 25.686 43.2177C23.3433 40.8933 21.855 38.0817 21.443 34.7532C21.4252 34.6095 21.6506 34.4351 21.8791 34.109C24.5562 34.816 23.9174 38.2633 26.2588 39.5402C27.24 35.1783 26.5005 31.0642 25.3642 27.0016C24.1906 22.8057 22.6341 18.762 20.1198 15.1594C17.6722 11.6526 14.6077 8.77185 11.2771 6.13815C7.93925 3.49878 4.17706 1.81146 0 0.795711Z" fill="#FFDE00"/>
      </svg>
    </div>

    <!-- <div class="coach-right">
      <h1 v-html="feature.title"></h1>
      <p v-for="(para, i) in feature.paragraphs()" :key="`para-${i}`" v-html="para"></p>
      <button class="coach-next" @click="next()">Next</button>
    </div> -->
  </div>
</template>

<script>
  import UserTrack from '@/components/v5/elements/UserTrack.vue';
  import MetaBlock from '@/components/v5/elements/MetaBlock.vue';

  export default {      
    props: {
      slide: {
        type: Object,
      },
      isActive: {
        type: Boolean,
      }
    },

    components: {
      UserTrack,
      MetaBlock
    },

    data() {
      return {
        progress: {
          time: 0,
          topics: 0,
          locales: 0,
        },

        templates: {
          'about-time': {
            // images: {
            //   dark: require('@assets/images/onboarding/onboarding-graphic-dark.png'),
            //   light: require('@assets/images/onboarding/onboarding-graphic-light.png'),
            // },
            icon: 'onboarding-wave',
            title: `Spend just enough <span class="callout">time</span> reading`,
            paragraphs: () => [
              `It's so easy to get caught in doom-scrolling, we've all done it. The <span class="callout">time</span> dial helps you build a new healthy habit.`,
            ],
            tabCallout: `How to build a<br> new healthy habit`,
            // meta: [
            //   {
            //     icon: 'meta-book',
            //     content: 'No clickbait<br>headlines',
            //   },
            //   {
            //     icon: 'meta-time',
            //     content: 'Quick daily<br>summaries',
            //   }
            // ]
            // paragraphs: () => [
            //   `We know we all do it…`,
            //   `You look at your phone to do something useful and before you know it you've lost 20 minutes to doom-scrolling.`,
            //   `Let's start by fixing that.`,
            // ]
          },
          'dial-time': {
            dial: 'time',
            title: `<span class="callout">5 minutes</span> a day`,
            paragraphs: () => [
              `Media is designed to eat your time and keep and attention. Nourish is designed to inform you quickly.`,
              `Your <span class="callout">time</span> dial shows you how much time you've spent reading. When it's full, you're read enough for the day!.`
            ],
            meta: [
              {
                icon: 'meta-book',
                content: 'Read 5 minutes<br>each day',
              },
              {
                icon: 'meta-time',
                content: 'Read channels<br>that interest you',
              }
            ]
            // dial: 'time',
            // title: `5 minutes a day`,
            // paragraphs: () => [
            //   `${this.sHabitIsAre} designed to eat your time and attention.`,
            //   `Nourish is designed to inform you, quickly … so you can get on with your day.`,
            //   `So this &ldquo;time&rdquo; dial shows you exactly how much time you've spent reading.`,
            //   `When the circle completes, you know you've read enough.`,
            // ],
          },



          'about-topics': {
            icon: 'onboarding-wave',
            title: `Detox with the right <span class="callout">topics</span>`,
            paragraphs: () => [
              `News is often hyper-focused on a few crisis stories, but there's so much more you should know about. This is where the <span class="callout">topic</span> dial shines.`,
            ],
            tabCallout: `How to build a<br> new healthy habit`,
            // images: {
            //   dark: require('@assets/images/onboarding/onboarding-graphic-dark.png'),
            //   light: require('@assets/images/onboarding/onboarding-graphic-light.png'),
            // },
            // title: `Beware<br/>the rabbit-hole…`,
            // paragraphs: () => [
            //   `News is often hyper-focused on a few crisis stories…`,
            //   `… leaving us all to believe that nothing good or interesting happens each day.`,
            //   `Let's see you what you're missing.`,
            // ]
          },
          'dial-topics': {
            dial: 'topics',
            title: `<span class="callout">Broaden</span> your mind`,
            paragraphs: () => [
              `${this.sHabitFocusUCF} on just a few themes, to keep your attention and clicking ads.`,
              `The <span class="callout">topic</span> dial keeps you focused on what's important. When it's full, you're read enough and you know you're getting a balanced diet.`,
            ],
            meta: [
              {
                icon: 'meta-book',
                content: 'Read topics<br>that interest you',
              },
              {
                icon: 'meta-time',
                content: 'Complete your green<br>dial each day',
              }
            ]
            // dial: 'topics',
            // title: `Broaden your mind`,
            // paragraphs: () => [
              // `${this.sHabitFocusUCF} on just a few themes, to keep your attention.`,
              // `So this &ldquo;topics&rdquo; dial helps you to see how many subjects you've really covered.`,
              // `When the circle completes, you know you're getting a balanced diet.`,
              
            // ],
          },


          'about-locales': {
            icon: 'onboarding-wave',
            title: `Explore a <span class="callout">world</span> of news`,
            paragraphs: () => [
              `It's a big world, but ${this.sHabitFocus} on just a few corners. Often obsuring the true context of global events. This is where the <span class="callout">countries</span> dial can help.`,
            ],
            tabCallout: `How to build a<br> new healthy habit`,
            // images: {
            //   dark: require('@assets/images/onboarding/onboarding-graphic-dark.png'),
            //   light: require('@assets/images/onboarding/onboarding-graphic-light.png'),
            // },
            // title: `Let's explore…`,
            // paragraphs: () => [
            //   `There's a whole world out there.`,
            //   `But ${this.sHabitFocus} on just a few corners of the world…`,
            //   `… often obscuring the true context of global events.`,
            // ]
          },
          'dial-locales': {
            dial: 'locales',
            title: `<span class="callout">Explore</span> the wider world`,
            paragraphs: () => [
              `Knowing more about the world puts other stories into perspective.`,
              `The <span class="callout">countries</span> dial shows you how many countries you've read about. When it's full, you've explored enough for one day.`,
            ],
            meta: [
              {
                icon: 'track-locales',
                content: 'Discover stories<br>around the world',
              },
              {
                icon: 'meta-time',
                content: 'Complete your blue<br>dial each day',
              }
            ]
            // dial: 'locales',
            // title: `Explore the world`,
            // paragraphs: () => [
            //   `Knowing about more of the world puts the the noisy stories into perspective.`,
            //   `So this &ldquo;countries&rdquo; dial shows how many countries you've read about.`,
            //   `When the circle completes, you know you've explored enough for one day.`,
            // ],
          },



          'detox': {
            theme: this.getStackFocus,
            icon: 'onboarding-focus',
            title: `The <span class="callout">challenge</span>`,
            paragraphs: () => [
              () => this.bFirst ? `For ${this.sDays}, try to avoid ${this.sHabit}. It suckers you into worrying about too many things over which you have no control.` : 
                                  `Remember to try avoiding ${this.sHabit} over the remaining ${this.sDays}. It suckers you into worrying about too many things over which you have no control.`,
              () => this.bFirst ? `Let us help you take a break. It's only for ${this.sDays}.` :
                                  `You're doing great! Only ${this.sDays} to go.`,
            ].map((a) => a()).filter(Boolean),
            tabCallout: `Dive into Nourish`,

            // detox: true,
            // title: `The important bit…`,
            // // looks weird, but allows runtime interpolation basically.
            // paragraphs: () => [
            //   () => this.bFirst ? `For ${this.sDays}, try to <strong>avoid ${this.sHabit}</strong>.` : 
            //                       `Remember to try avoiding ${this.sHabit} over the remaining ${this.sDays}.`,
            //   () => this.bFirst ? `We know that's a hard ask …` : 
            //                       ``,
            //   () => this.bFirst ? `… but ${this.sHabitSuckers} you into worrying about too many things over which you have no control.` : 
            //                       ``,
            //   () => this.bFirst ? `Let us help you take a break.  It's only for ${this.sDays}.` :
            //                       `You're doing great! Only ${this.sDays} to go.`,
            // ].map((a) => a()).filter(Boolean),
          },
        } 
      }
    },

    computed: {
      feature() {
        return this.templates[this.slide?.slug] || {};
      },
      sDays() {
        return this.$coachingEngine.sDaysRemain;
      },
      sHabit() {
        return this.$coachingEngine.sHabit;
      },
      sHabitIsAre() {
        return this.$coachingEngine.sHabitIsAre;
      },
      sHabitFocus() {
        return this.$coachingEngine.sHabitFocus;
      },
      sHabitFocusUCF() {
        return String(this.$coachingEngine.sHabitFocus).charAt(0).toUpperCase() + String(this.$coachingEngine.sHabitFocus).slice(1);
      },
      sHabitSuckers() {
        return this.$coachingEngine.sHabitSuckers;
      },
      bFirst() {
        return this.$coachingEngine.getDialActive.length == 1;
      },
      getStackFocus() {
        return this.$route.params?.slug?.replace(/.*:/, '');
      },
      getDetox() {
        switch (this.getStackFocus) {
          case 'time':
            return 'onboarding-clock';
          case 'topics': 
            return 'onboarding-book';
          case 'locales':
            return 'onboarding-globe';
          default: return ''
        }
      }
    },

    mounted() {
      if (this.isActive) {
        this.slideActivated();
      }
    },

    methods: {
      slideActivated() {
        this.autoEnableNext();
      },

      autoEnableNext() {
        const delay = 2.5;
        window.setTimeout(() => {
          this.$emit('enableNextAction');
        }, 1000 * delay);
      },

      next() {
        this.$emit('next');
      }
    },

    watch: {
      getStackFocus() {
        this.slideActivated();
      },

      isActive(to) {
        if (to) {
          this.slideActivated();
        }
      }
    }
  }
</script>

<style lang="scss" scoped>
  @import 'src/assets/scss/v5_stacks.scss';

  .content {
    padding-bottom: 2rem;

    // .dial-container {
    //   margin: 0 auto 1rem auto;
    // }

    .detox-container {
      display: flex;
      align-items: flex-start;
      justify-content: flex-start;
      margin-bottom: 2rem;

      .desktop & {
        align-items: center;
        justify-content: center;
      }

      .icon {
        position: relative;
        margin-right: 1rem;
        display: flex;
        align-items: center;
        justify-content: center;
        padding: 1.5rem;
        border-radius: 500px;

        &.time {
          border: 2px solid $time-tone;

          svg {
            fill: $time-tone;
          }
        }

        &.topics {
          border: 2px solid $topics-tone;

          svg {
            fill: $topics-tone;
          }
        }

        &.locales {
          border: 2px solid $locales-tone;

          svg {
            fill: $locales-tone;
          }
        }
      }
    }
    
    .image-container {
      margin: 0 0 2rem 0;

      img {
        width: 100%;
        max-width: 400px;
        object-fit: contain;
      }

      .dark {
        display: none;
      }

      .darkmode & {
        .light {
          display: none;
        }

        .dark {
          display: inline-block;
        }
      }
    }

    h1, p {
      text-align: center;
      text-wrap: balance;
    }

    h1 {
      font-size: 36px;
      margin-bottom: 1rem;
    }
  }

  .card-coaching {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    max-width: 550px;
    margin: 0 auto;
    overflow-x: hidden;
    height: 100%;
    gap: 1rem;

    .coach-left {
      display: flex;
      flex-direction: column;
      align-items: flex-start;

      .desktop & {
        align-items: center;
        margin: 0 auto;
      }
    }

    .coach-right {
      flex-direction: column;
      align-items: center;
      flex: 1;
      text-align: center;

      .coach-next {
        display: none;
        min-width: 100px;
      }
    }

    .onboarding-content {
      display: flex;
      flex-direction: column;
      align-items: flex-start;
      text-align: left;
      gap: 1rem;
      z-index: 10;

      .desktop & {
        align-items: center;
        text-align: center;
        width: 100%;
      }

      .paragraph-group {
        display: flex;
        flex-direction: column;
        gap: 1rem;
        max-width: 500px;
        margin: 0 auto;
      }

      h1 {
        font-size: 50px;
        line-height: 100%;
        font-weight: normal;
        text-wrap: balance;
        text-align: left;

        .desktop & {
          font-size: 70px;
          text-align: center;
        }

        ::v-deep {
          .callout {
            color: $yellow-tone-4;

            .darkmode & {
              color: $yellow-tone-3;
            }
          }
        }

        &.time {
          ::v-deep {
            .callout {
              color: $yellow-tone-4;

              .darkmode & {
                color: $time-tone;
              }
            }
          }
        }

        &.topics {
          ::v-deep {
            .callout {
              color: $green-tone-3;

              .darkmode & {
                color: $topics-tone;
              }
            }
          }
        }

        &.locales {
          ::v-deep {
            .callout {
              color: $blue-tone-3;

              .darkmode & {
                color: $locales-tone;
              }
            }
          }
        }
      }

      p {
        font-size: 20px;
        line-height: 150%;
        text-wrap: balance;
        text-align: left;

        .desktop & {
          text-align: center;
        }

        ::v-deep {
          .callout {
            color: $yellow-tone-4;

            .darkmode & {
              color: $yellow-tone-3;
            }
          }
        }

        &.time {
          ::v-deep {
            .callout {
              color: $yellow-tone-4;

              .darkmode & {
                color: $time-tone;
              }
            }
          }
        }

        &.topics {
          ::v-deep {
            .callout {
              color: $green-tone-3;

              .darkmode & {
                color: $topics-tone;
              }
            }
          }
        }

        &.locales {
          ::v-deep {
            .callout {
              color: $blue-tone-3;

              .darkmode & {
                color: $locales-tone;
              }
            }
          }
        }
      }
    }

    .meta-block {
      z-index: 10;
      width: 100%;
      max-width: 400px;
      margin: 0 auto;
      margin-top: 2rem;
      // jim's hack
      // position: absolute;
      // bottom: 4.5rem;
      // max-width: 90vw;
      // left: 1rem;
      // right: 1rem;
    }

    .image-icon {
      margin-bottom: 2rem;

      .desktop & {
        margin: 0 auto 1rem 0;
      }

      svg {
        fill: $yellow-tone-4;

        .darkmode & {
          fill: $yellow-tone-3;
        }
      }

      &.time {
        svg {
          fill: $yellow-tone-4;

          .darkmode & {
            fill: $time-tone;
          }
        }
      }

      &.topics {
        svg {
          fill: $green-tone-3;

          .darkmode & {
            fill: $topics-tone;
          }
        }
      }

      &.locales {
        svg {
          fill: $blue-tone-3;

          .darkmode & {
            fill: $locales-tone;
          }
        }
      }
    }

    // @media (min-width: 750px) {
    //   display: grid;
    //   grid-template-columns: 1fr 1fr;
    //   height: 75vh;

    //   .coach-left,
    //   .coach-right {
    //     align-self: center;
    //   }

    //   .coach-right {
    //     display: flex;

    //     .coach-next {
    //       display: inline-block;
    //     }
    //   }
    // }
  }
</style>